const PERMITTED_SENDER_MESSAGES = {
    no_senders: 'We have not been able to identify any senders based on your email traffic.',
    warning: 'The following senders are sending for domains in this group. Please review each sender and identify which domains they are permitted for. This is required for proper categorization of data, reporting, and surfacing Actions for each sender.',
};

export default PERMITTED_SENDER_MESSAGES;
